import React, { useContext, useEffect } from "react";
import { UserContext } from "../../../contexts/userProvider";
import { ChangeLanguage } from "../../../utils/requests/users";

const LangHandler: React.FC = () => {
  const { userStore, dispatch } = useContext(UserContext);
  const { userInfos } = userStore;
  const userLanguage = userInfos?.language;

  useEffect(() => {
    const localLang = localStorage.getItem("lng")?.substring(0, 2);

    // check if api lang is the same
    if (localLang && userInfos?.isOnline && userLanguage !== localLang) {
      // change lang in api
      ChangeLanguage(localLang)
        .then(() => {
          window.location.reload(); // reload page to apply new lang
        })
        .catch((error: any) => {
          console.error(error.response?.data?.error || error?.message);
        });
    }
  }, [dispatch, userInfos, userLanguage]);
  return null;
};

export default LangHandler;
